export default function CustomToolTip({ text }: { text: string }) {
  return (
    // ADD classes "group" and "relative" to the parent
    <p className="absolute z-10 bottom-[-1.7rem] left-0 rounded-md px-2 py-1  bg-dark-bgColor  text-sm text-green-200 invisible  -translate-y-3 transition-all group-hover:visible group-hover:opacity-[.8] group-hover:translate-y-0">
      {text}
    </p>
  );
}
